import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }

    .sgdf-navbar-item {
        display: flex;
        white-space: nowrap;
        transition:
            var(--transition-speed) box-shadow,
            var(--transition-speed) color;
        color: white;
        text-transform: uppercase;
        align-items: center;
        cursor: pointer;
        border-bottom: var(--sgdf-spacing-2x-small) solid
            var(--sgdf-color-default);
        padding: var(--sgdf-spacing-small) var(--sgdf-spacing-small);
    }

    .sgdf-navbar-item:hover:not(.navbar--active) {
        /* box-shadow: inset 0 -0.3em 0px var(--sgdf-color-primary-600); */
        border-bottom: var(--sgdf-spacing-2x-small) solid
            var(--sgdf-color-primary-600);
    }

    .navbar--active {
        /* background-color: var(--sgdf-color-primary-600); */
        /* box-shadow: inset 0 -0.3em 0px rgba(255,255,255,0.6); */
        border-bottom: var(--sgdf-spacing-2x-small) solid
            var(--sgdf-color-light);
    }

    ::slotted(a) {
        user-select: none;
        color: white;
        text-decoration: none;
    }
`;
//# sourceMappingURL=NavBarItem.styles.js.map